"use client";

import { cn } from "./cn";
import { I } from "./Icons";

export function FormSection({
  title,
  children,
  collapsible,
  open,
  onToggle,
  headerAction,
  className,
}: {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  open?: boolean;
  onToggle?: () => void;
  headerAction?: React.ReactNode;
  className?: string;
}) {
  const titleEl = (
    <h3 className="text-[11px] font-bold uppercase tracking-wider text-[#475467]">
      {title}
    </h3>
  );

  return (
    <section className={className}>
      <div className="mb-2 flex w-full items-center justify-between gap-2">
        {collapsible ? (
          <button
            type="button"
            onClick={onToggle}
            className="flex min-w-0 flex-1 items-center justify-between cursor-pointer"
            aria-expanded={open}
          >
            {titleEl}
            <span
              className={cn(
                "h-4 w-4 shrink-0 text-[#98A2B3] transition-transform",
                open && "rotate-180",
              )}
            >
              {I.chevronDown}
            </span>
          </button>
        ) : (
          titleEl
        )}
        {headerAction ? (
          <div className="shrink-0">{headerAction}</div>
        ) : null}
      </div>
      {(!collapsible || open) && <div>{children}</div>}
    </section>
  );
}

export function FormField({
  label,
  required,
  children,
  htmlFor,
  className,
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  htmlFor?: string;
  className?: string;
}) {
  return (
    <div className={className}>
      <label
        htmlFor={htmlFor}
        className="mb-1 block text-[12px] font-semibold text-[#344054]"
      >
        {label}
        {required ? <span className="ml-0.5 text-[#F04438]">*</span> : null}
      </label>
      {children}
    </div>
  );
}

export const crmInputClass =
  "w-full h-10 rounded-lg border border-[#E4E7EC] bg-white px-2.5 transition-colors hover:bg-slate-50 text-[13px] text-[#101828] placeholder:text-[#98A2B3] outline-none focus:border-brand focus:ring-2 focus:ring-brand/15 transition";
